import {Component} from '@angular/core';
import {IonButton, IonCard, IonCardContent} from '@ionic/angular/standalone';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-meet-us-in-person',
  templateUrl: './meet-us-in-person.component.html',
  styleUrls: ['./meet-us-in-person.component.scss'],
  imports: [
    IonCard,
    IonCardContent,
    IonButton,
    TranslateModule
  ],
  standalone: true
})
export class MeetUsInPersonComponent {
  showCalendly = false;

  toggleCalendly() {
    this.showCalendly = !this.showCalendly;
  }
}
